import request from "@/utils/http.js";
import website from "@/config/website";

/* 登录 */
export const loginByUsername = (
  tenantId,
  username,
  password,
  type,
  key,
  code,
  dataType
) =>
  request({
    url: "/api/blade-auth/oauth/token",
    method: "post",
    headers: {
      "Tenant-Id": tenantId,
      "Captcha-Key": key,
      "Captcha-Code": code,
    },
    params: {
      tenantId,
      username,
      password,
      grant_type: website.captchaMode ? "captcha" : "password",
      scope: "all",
      type,
      dataType
    },
  });
/* 退出 */
export const logout = () =>
  request({
    url: "/api/blade-auth/oauth/logout",
    method: "get",
    authorization: false,
  });
/* 获取验证码 */
export const getCaptcha = () =>
  request({
    url: "/api/blade-auth/oauth/captcha",
    method: "get",
    authorization: false,
  });

/* 机构入驻-注册 */
export function institutionEnter(data) {
  return request({
    url: `/api/blade-base/institution/enter`,
    method: "POST",
    data,
  });
}

/* 院校入驻-注册 */
export function academyEnter(data) {
  return request({
    url: `/api/blade-base/academy/enter`,
    method: "POST",
    data,
  });
}